/*
 * Home Sticky Buy bar — toggles `.show` class on the bar based on whether
 * the hero section is in view. When the hero leaves the viewport, the bar
 * slides up; when the hero comes back into view, the bar slides down.
 *
 * Hero selector is configurable via the script tag's `data-hero-selector`
 * attribute (defaults to `.home-hero`).
 *
 * Source behaviour: EarnItKid Home Desktop.html lines 3660-3666.
 *
 * Theme Editor support: re-observes when either the hero or sticky bar
 * section is re-rendered via `shopify:section:load`. The previous observer
 * (or scroll fallback) is torn down before a new one is created so we
 * don't stack listeners. In Shopify design mode the bar is disabled
 * entirely so it doesn't cover content while a merchant is editing.
 */
(function () {
  var script =
    document.currentScript ||
    document.querySelector('script[src*="home-sticky-buy.js"]');
  var heroSelector =
    (script && script.getAttribute('data-hero-selector')) || '.home-hero';

  var IS_DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  var observer = null;
  var scrollHandler = null;
  var scrollHero = null;

  function teardown() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
      scrollHero = null;
    }
  }

  function init() {
    teardown();

    var bar = document.getElementById('home-sticky-buy');
    var hero = document.querySelector(heroSelector);

    if (!bar || !hero) return;

    // Disable sticky behavior in Theme Editor so it doesn't cover the
    // section a merchant is currently editing.
    if (IS_DESIGN_MODE) {
      bar.classList.remove('show');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      scrollHero = hero;
      scrollHandler = function () {
        var rect = scrollHero.getBoundingClientRect();
        bar.classList.toggle('show', rect.bottom <= 0);
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
      scrollHandler();
      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('show', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(hero);
  }

  init();

  // Theme Editor: re-init when either the hero or sticky-bar section is
  // re-rendered — we don't know which `e.target` is, so just refresh both.
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  document.addEventListener('shopify:section:unload', function () {
    // If the hero or bar was removed entirely, tear down so we don't keep
    // observing a detached node.
    init();
  });
})();
